import * as React from "react";

import { Box, Typography } from "@material-ui/core";

import { Page } from "../Page";
import { IPageProps } from "../IPageProps";

import { IHttpRequest, Status, useHttp } from "Utility/useHttp";

import { QuiltCanvas } from "Components/QuiltCanvas";
import { IQuiltRenderData } from "Model/IQuiltRenderData";

export function DownloadPage(props: IPageProps): React.ReactElement {
    const [request, setRequest] = React.useState<IHttpRequest | null>(null);
    const quiltLoadState = useHttp<IQuiltRenderData>(request);

    React.useEffect(() => {
        setRequest({
            method: "post",
            url: "/api/quilt/generate",
            data: props.params
        })
    },
    [props.params]);

    const [saving, setSaving] = React.useState(false);
    const [imageUrl, setImageUrl] = React.useState<string | null>(null);

    const [imageW, setImageW] = React.useState(0);
    const [imageH, setImageH] = React.useState(0);

    const width = Math.floor(window.devicePixelRatio * window.screen.availWidth);
    const height = Math.floor(window.devicePixelRatio * window.screen.availHeight);

    const renderCallback = (context: CanvasRenderingContext2D) => {
        if (saving) {
            return;
        }

        setSaving(true);

        context.canvas.toBlob((blob) => {
            // Actual canvas W / H will not match what we pass in.
            setImageW(context.canvas.width);
            setImageH(context.canvas.height);
            setImageUrl(URL.createObjectURL(blob));
        });
    }

    const renderData = quiltLoadState.status === Status.Complete ? quiltLoadState.data : null;

    return (
        <Page>
            <Box>
                {imageUrl === null && renderData !== null &&
                    <QuiltCanvas renderData={renderData} width={width} height={height} renderCallback={renderCallback}/>
                }

                {imageUrl !== null &&
                    <img src={imageUrl} width={imageW} height={imageH} alt="quilt"/>
                }

                {quiltLoadState.status === Status.Error &&
                    <Typography color="error">Failed to load quilt.</Typography>
                }
            </Box>
        </Page>
    )
}